import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { IndexCard } from '@/types'
import './IndexCard.css'

interface IndexCardListItemProps {
  indexCard: IndexCard
}

export function IndexCardListItem({ indexCard }: IndexCardListItemProps) {
  const { t } = useTranslation()

  return (
    <Link to={`/index/${indexCard.id}`} className="index-card-item">
      <h4 className="index-card-keyword">{indexCard.keyword}</h4>
      {indexCard.description && (
        <p className="index-card-description">{indexCard.description}</p>
      )}
      <div className="index-card-meta">
        {indexCard.references.length} {t('index.references')}
      </div>
    </Link>
  )
}
